import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeaderTransprent from "../../components/HeaderTransprent";
import Footer from "../../components/Footer";
import Testimonial2 from "../../ui/Testimonial2";
import ContactForm from "../../ui/ContactForm";
import AllCompnayLogo from "../../ui/AllCompnayLogo";
import ButtonPage from "../../ui/ButtonPage";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
      <div className="overflow-hidden">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Unlock your workforce potential with our skills-based talent  intelligence platform and psychometric assessments for smarter hiring.</title>
          <meta name="description" content="Unlock talent potential with our psychometric assessments backed platform for employee Personality assessment. Optimize your workforce potential now!" />
          <link rel="canonical" href="https://www.talentplusstrengths.com/#/assessment/home" />
        </Helmet>

        <section className="bg-[#2196F3]/10 w-full h-auto bg-cover bg-no-repeat bg-right" style={{ backgroundImage: `url('/img/home/hero-bg.webp')`, }}>
          <HeaderTransprent />

          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full gap-10 md:py-20 md:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="flex flex-col justify-center w-full h-full pt-10 lg:mr-10 mr-0 mx-auto my-auto space-y-8 text-center md:pb-12 md:pt-0 md:text-left">
                <h1 data-aos="fade-right" className="xl:text-6xl lg:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold textcolor capitalize">Everything we do should add (+) Happiness in this world</h1>
                <div data-aos="fade-right" className="text-base font-medium md:text-lg">
                  <p className="text-[#212121]">HappyPlus Consulting is on a mission to reshape the narrative around workplace happiness and wellbeing. We are committed to collaborating with organizations to foster a culture that prioritizes the happiness and wellbeing of employees along with business growth.</p>
                </div>
                <div className="flex flex-row items-center justify-center gap-4 md:justify-start md:items-center">
                  <ButtonPage text="Get Certified" onClick={() => ""} />
                </div>
              </div>

              <div className="flex items-center justify-center w-full lg:justify-end">
                <img data-aos="fade-left" src="/img/home/happiest-workplace.webp" alt="re-discover-yourself-using" className="z-0" />
              </div>
            </div>
          </div>
        </section>

        {/* <section className="w-full h-auto bg-cover bg-no-repeat bg-right bg-[#D81B60]"
          style={{
            backgroundImage: `url('/img/home/bg-02.webp')`,
          }}>
          <div className="w-full h-full">
            <div className="flex flex-col justify-center items-center w-full h-full gap-10 py-20 md:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="grid lg:grid-cols-5 grid-cols-1 gap-8 w-full">
                <h1 className="xl:text-7xl lg:text-6xl text-4xl font-bold text-white col-span-2 lg:text-start text-center tracking-wide">Everything we do should add (+) Happiness in this world</h1>
                <div className="col-span-3 text-left flex flex-col justify-center items-center">
                  <p className="lg:text-lg xl:text-xl text-lg text-white mb-6">
                    HappyPlus Consulting is on a mission to reshape the narrative around workplace happiness and wellbeing. We are committed to collaborating with organizations to foster a culture that prioritizes the happiness and wellbeing of employees along with business growth. As part of our dedication, we proudly present the esteemed ‘Happiness and Wellbeing Research’ to honor employers who exemplify outstanding initiatives in promoting employee happiness and wellbeing. Through our initiatives, we aim to spread happiness and create a ripple effect of positivity that extends beyond the workplace, impacting lives and communities. Together, let’s celebrate and inspire a new era of thriving workplaces.
                  </p>
                  <p className="lg:text-lg xl:text-xl text-lg text-white">
                    An in-depth research on the best practices adopted by companies in India and celebration of the same with other great companies. We are looking forward to creating a world, where happiness and wellbeing are the source of sustainable business performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* <section className="w-full px-4 py-20 mx-auto space-y-6 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0 ">
          <div className="space-y-2">
            <h1 data-aos="fade-up" className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold textcolor capitalize">What Do We Offer</h1>
          </div>
          <p className="text-xl text-[#212121] mt-4">We are the gold standard for workplace culture through research backed methodologies.</p>
        </section> */}

        <div className="space-y-16">
          <section className="flex flex-col-reverse items-center w-full gap-10 px-4 pt-10 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row ">
            <div data-aos="fade-right" className="w-full space-y-6">
              {/* <span className="textcolor uppercase font-medium"></span> */}
              <h2 className="md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]">Our Being</h2>
              <p className="text-xl text-[#212121]">Accelerate Business Growth. Create Sustainable, Healthy, and Happy Workplaces</p>
              <p className="text-xl text-[#212121]">Our purpose is to create happier workplaces by impacting millions of employees through awareness and empowerment. We are on a transformative journey, reshaping the perception of happiness in the workplace and life, and translating it into a tangible reality for individuals and organizations.</p>
              {/* <LearnMore text="Learn More" /> */}
            </div>
            {/* img */}
            <div className="w-full">
              <img alt="assessment_survey" data-aos="fade-left" src="/img/about/about.png" width={992} height={582} />
            </div>
          </section>

          <section className="flex flex-col items-center w-full gap-10 px-4 pb-20 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row ">
            <div className="w-full">
              <img alt="summary_report" data-aos="fade-right" src="/img/about/about.png" width={992} height={582} />
            </div>
            {/* text */}
            <div data-aos="fade-left" className="w-full space-y-6">
              {/* <span className="textcolor uppercase font-medium"></span> */}
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-[#212121]">Our Priority</h2>
              <p className="text-xl text-[#212121]">At the core of our mission lies a deep commitment to honor and applaud your resolute dedication in creating a workplace where happiness and wellbeing thrive.</p>
              <p className="text-xl text-[#212121]">We are here to recognize and celebrate your unwavering efforts in fostering a forward-thinking culture that embraces the holistic approach of happiness, wellbeing, and business performance.</p>
              {/* <LearnMore text="Learn More" /> */}
            </div>
          </section>
        </div>

        <section className="relative bg-white">
          <div className="absolute inset-0">
            <img className="object-cover object-right w-full h-full lg:object-center" src="/img/home/bg-04.webp" alt="" />
          </div>
          {/* <div className="absolute inset-0"></div> */}
          <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="relative">
              <div className="w-full text-center">
                <h2 className="text-4xl font-bold text-white sm:text-4xl xl:text-6xl pb-2">Transforming India Into the</h2>
                <h2 className="text-4xl font-bold text-white sm:text-4xl xl:text-6xl">Best Workplaces for Everyone</h2>
                <div className="grid md:grid-cols-3 grid-cols-1 mx-auto gap-12 grid-col-2 pt-10">
                  <div className="hover:bg-gradient-to-b hover:from-black/25 hover:to-transparent rounded-xl px-4 py-8">
                    <img className="mx-auto w-24 h-24" src="/img/home/employees-surveyed.svg" alt="" />
                    <div className="pt-6">
                      <p className="text-6xl font-bold text-white">100K+</p>
                      <p className="mt-2 text-sm font-medium text-gray-300">Employees Surveyed</p>
                    </div>
                  </div>
                  <div className="hover:bg-gradient-to-b hover:from-black/25 hover:to-transparent rounded-xl px-4 py-8">
                    <img className="mx-auto w-24 h-24" src="/img/home/organizations.svg" alt="" />
                    <div className="pt-6">
                      <p className="text-6xl font-bold text-white">100+</p>
                      <p className="mt-2 text-sm font-medium text-gray-300">Organizations</p>
                    </div>
                  </div>
                  <div className="hover:bg-gradient-to-b hover:from-black/25 hover:to-transparent rounded-xl px-4 py-8">
                    <img className="mx-auto w-24 h-24" src="/img/home/trophy.svg" alt="" />
                    <div className="pt-6">
                      <p className="text-6xl font-bold text-white">100+</p>
                      <p className="mt-2 text-sm font-medium text-gray-300">Award Distributed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AllCompnayLogo />

        <Testimonial2 />


        <section className="bg-cover bg-no-repeat" style={{ backgroundImage: `url('/img/home/bg-03.webp')`, }}>
          <div className="flex flex-col justify-start w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 py-12 w-full">
              <div className="flex flex-col lg:flex-row">

                <div className="lg:w-1/2 flex flex-col justify-center mb-8 md:mb-0 pr-0 md:pr-8">
                  <h1 className="text-4xl md:text-5xl font-bold textcolor mb-6 leading-tight">
                    Ready to leap from feedback to action?
                  </h1>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">
                    Invest in your people today.<br />
                    If not now, when?
                  </h2>
                  <p className="text-lg text-gray-700">
                    Let's build an organization where, people feel good about how they contribute to the whole!
                  </p>
                </div>

                <ContactForm />

              </div>
            </div>
          </div>
        </section>

        {/* <Ready /> */}

        <Footer />
      </div>
    </>
  );
};

Home.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};

export default Home;
